/**
 * The page numbers a `Pagination` footer shows: a sliding window of five
 * around the current page — the prototype's `views/tables/pageWindow.ts`.
 *
 * `Pagination` renders every page it is given and leaves windowing to the
 * caller, because Figma has no ellipsis or overflow variant to follow. The
 * frame draws exactly five number buttons, so five is the window — kept
 * centred on the current page where it can be and pinned to either end where it
 * cannot, so it never shows fewer than five while five exist.
 */
export const PAGE_WINDOW = 5;

export function pageWindow(page: number, pageCount: number, size: number = PAGE_WINDOW): number[] {
  const count = Math.min(size, pageCount);
  const start = Math.min(Math.max(1, page - Math.floor(count / 2)), pageCount - count + 1);
  return Array.from({ length: count }, (_, i) => start + i);
}
